//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CurrentDialog from "./CurrentDialog";
export default {
  name: "LeftTree",
  data() {
    return {
      keyWord: "", // 搜索关键字
      businessZoneList: [], // 业务区域树
      // tree more 按钮数据
      handles: [
        { label: "添加子区域", id: 2, w: "400px", btn: "保存" },
        { label: "修改名称", id: 3, w: "400px", btn: "保存" },
        { label: "设置负责人", id: 4, w: "500px", btn: "确认" },
        { label: "删除", id: 5, w: "400px", btn: "删除" },
        { label: "上移", id: 6 },
        { label: "下移", id: 7 },
      ],
      currentId: null, // 当前选中nodekey
      showDialog: false, // 弹框显示
      dialogObj: {}, // 弹框类型
      areaData: {}, // 当前点击区域
    };
  },
  components: { CurrentDialog },
  computed: {
    hideDropdown() {
      return (data, item, node) => {
        let flag = true;
        switch (item.id) {
          case 6:
            flag = data.orderNum !== 1;
            break;
          case 7:
            if (node.level == 1) {
              flag = data.orderNum != node.parent.data.length;
            } else {
              flag = data.orderNum != node.parent.data.children.length;
            }
            break;
          default:
            break;
        }
        return flag;
      };
    },
    hideBorder() {
      return (data, item, node) => {
        let flag = false;
        if (item.id == 6) {
          if (node.level == 1) {
            flag = data.orderNum == node.parent.data.length;
          } else {
            flag = data.orderNum == node.parent.data.children.length;
          }
        }
        if (item.id == 5) {
          if (node.level == 1) {
            flag =
              data.orderNum == node.parent.data.length && data.orderNum == 1;
          } else {
            flag =
              data.orderNum == node.parent.data.children.length &&
              data.orderNum == 1;
          }
        }
        return flag;
      };
    },
  },
  methods: {
    /**
     * @description:搜索成员和区域
     * @Author: yangsibo
     * @Date: 2022-05-12 09:32:23
     */
    handleFilter() {
      this.$refs["my-tree"].filter(this.keyWord);
    },
    /**
     * @description: 添加区域
     * @Author: yangsibo
     * @Date: 2022-05-12 09:35:22
     */
    addArea() {
      this.dialogObj = { label: "添加区域", w: "400px", id: 1, btn: "保存" };
      this.showDialog = true;
    },
    /**
     * @description: 获取业务区域树
     * @Author: yangsibo
     * @Date: 2022-05-12 10:20:36
     */
    async getBusinessZoneList(callback) {
      try {
        let { data } = await this.$http.common.getBusinessZoneList();
        data.forEach((item) => {
          item.level = 1;
        });
        this.businessZoneList = data;
        callback && callback();
      } catch (error) {}
    },
    /**
     * @description: 树形结构更多按钮操作
     * @Author: yangsibo
     * @Date: 2022-05-12 14:06:41
     * @param {*} node
     * @param {*} data
     * @param {*} id
     */
    handleNode(node, data, item) {
      if (item.id < 6) {
        this.dialogObj = item;
        this.areaData = data;
        this.areaData.orderNum = data.children ? data.children.length + 1 : 1;
        this.showDialog = true;
      } else {
        let switchLevel = item.id == 6 ? 1 : 0;
        this.switchOrder(data.id, switchLevel);
      }
    },
    /**
     * @description: 上移下移
     * @Author: yangsibo
     * @Date: 2022-05-12 18:12:12
     * @param {*} id 操作类型
     * @return {*}
     */
    async switchOrder(id, switchLevel) {
      try {
        let { status } = await this.$http.business.switchOrder({
          id,
          switchLevel,
        });
        if (status === "1") {
          this.$message({
            type: "success",
            message: `${switchLevel ? "上移" : "下移"}成功`,
            duration: 2000,
          });
          this.getBusinessZoneList(() => {
            this.$nextTick(() => {
              this.$refs["my-tree"].setCurrentKey(this.currentId);
            });
          });
        }
      } catch (error) {}
    },
    /**
     * @description: 点击树形结构节点
     * @Author: yangsibo
     * @Date: 2022-05-12 14:08:53
     * @param {*} data 当前点击的节点
     */
    handleNodeClick(data) {
      this.setCurrentId(data);
    },
    /**
     * @description: 设置currentId
     * @Author: yangsibo
     * @Date: 2022-05-12 14:25:47
     */
    setCurrentId(data) {
      this.$emit("getCurrentId", data);
    },
    /**
     * @description: tree搜索回调
     * @Author: yangsibo
     * @Date: 2022-05-12 17:29:02
     * @param {String} value 搜索关键字
     * @param {Object} data 节点数据
     * @return {Boolean} 是否过滤
     */
    filterNode(value, data) {
      if (!value) return true;
      return data.zoneName.indexOf(value) !== -1;
    },
    /**
     * @description: 关闭弹窗
     * @Author: yangsibo
     * @Date: 2022-05-12 17:58:25
     */
    close() {
      this.showDialog = false;
    },
  },
  created() {
    this.getBusinessZoneList(() => {
      this.$nextTick(() => {
        const { zoneName, id } = this.businessZoneList[0];
        this.currentId = id;
        this.$refs["my-tree"].setCurrentKey(this.currentId);
        this.setCurrentId({ zoneName, id });
      });
    });
  },
  mounted() {},
};
